import { requestJoinDemoStore } from "src/lib/demoStore";

/**
 * Opens the UI destination for an onboarding task.
 *
 * @param {object} params
 * @param {object | null | undefined} params.action
 * @param {(updater: Function) => void} [params.setSettingsDialogState]
 * @param {(state: { open: boolean, source: string }) => void} [params.setPaywallState]
 */
export const openOnboardingAction = ({
  action,
  setSettingsDialogState,
  setPaywallState,
}) => {
  if (!action) {
    return;
  }

  switch (action.type) {
    case "shopify_listing":
      window.open(process.env.SHOPIFY_LISTING_URL, "_blank");
      return;
    case "settings":
      setSettingsDialogState((prev) => ({
        ...prev,
        open: true,
        activeTab: action.tab || prev.activeTab,
        manageParam: action.manageParam || null,
        sectionTarget: action.sectionTarget || null,
        sectionTargetNonce: Date.now(),
      }));
      return;
    case "paywall":
      setPaywallState?.({
        open: true,
        source: action.source || "onboarding",
      });
      return;
    case "demo_store":
      requestJoinDemoStore();
      return;
  }
};
